import VueCqrs from '@cqrs/vue-component-cqrs';
import { ProjectUser } from '@Projects/Model';
import * as c from '@ProjectUsers/Domain/commands-core';
import Component from 'vue-class-component';

@Component
export default class ProjectUserCommands extends VueCqrs {

	invokeCreateProjectUsersCommandV1(workspaceId: number, projectId: number, projectUsers: ProjectUser[])
	{
		const cmd = new c.CreateProjectUsersCommandV1(workspaceId, projectId, projectUsers);
		this.$command(cmd, projectId.toString());
	}

	invokeDeleteProjectUserCommandV1(workspaceId: number, projectId: number, projectUserId: number)
	{
		const cmd = new c.DeleteProjectUserCommandV1(workspaceId, projectId, projectUserId);
		this.$command(cmd, projectUserId.toString());
	}

	invokeUpdateProjectUserCommandV1(workspaceId: number, projectId: number, projectUserId: number, newName: string, newEmail: string, newTags: string[], oldName: string, oldEmail: string, oldTags: string[])
	{
		const cmd = new c.UpdateProjectUserCommandV1(workspaceId, projectId, projectUserId, newName, newEmail, newTags, oldName, oldEmail, oldTags);
		this.$command(cmd, projectUserId.toString());
	}

	invokeResetProjectUserAccessTokenCommandV1(workspaceId: number, projectId: number, projectUserId: number)
	{
		const cmd = new c.ResetProjectUserAccessTokenCommandV1(workspaceId, projectId, projectUserId);
		this.$command(cmd, projectUserId.toString());
	}

	invokeArchiveProjectUserCommandV1(workspaceId: number, projectId: number, projectUserId: number)
	{
		const cmd = new c.ArchiveProjectUserCommandV1(workspaceId, projectId, projectUserId);
		this.$command(cmd, projectUserId.toString());
	}

	invokeUnarchiveProjectUserCommandV1(workspaceId: number, projectId: number, projectUserId: number)
	{
		const cmd = new c.UnarchiveProjectUserCommandV1(workspaceId, projectId, projectUserId);
		this.$command(cmd, projectUserId.toString());
	}
}
